import { memo } from 'react';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import { useStore } from '@/shared/store/app';
import './NavigationOverlay.css';

/**
 * NavigationOverlay
 *
 * Full-screen opaque overlay with a centered loading spinner displayed
 * while a cross-portal IAM change-app navigation is in progress.
 *
 * Mounted once in `HomeLayout` and driven by the global `isNavigating`
 * flag in the app store — all `useChangeApp` callers are covered
 * automatically without any per-component wiring.
 *
 * @since 1.0.0
 * @category Components/Atoms
 */
const NavigationOverlay = memo(() => {
  const { t } = useTranslation();
  const isNavigating = useStore((s) => s.isNavigating);

  if (!isNavigating) return null;

  return (
    <div
      className="navigation-overlay"
      role="status"
      aria-live="polite"
      aria-label={t('Navigating to application...')}
      data-testid="navigation-overlay"
    >
      <Spin size="large" />
    </div>
  );
});

NavigationOverlay.displayName = 'NavigationOverlay';

export default NavigationOverlay;
